// Tuesday, 20 October 2026: inboxes gained email_aliases and respond_from_alias_id
// Change this version if you want to invalidate old data
export const DATA_VERSION = 1792488786;
